import { Role } from "../models/role";
import { fetchData } from "../../Utils/fetchData";
import authToken from "../../Utils/authToken";
import { ROLE_ENDPOINTS } from "./endpoints";
import { ApiResponse } from "../../types/api.types";

export async function countUserLogins({ userId, from, to }: { userId: string, from: string, to: string }) {
  const params = new URLSearchParams({ userId, from, to });
  const response = await fetchData(`/userLogin/count?${params.toString()}`, {
    method: "GET",
    headers: {
      Authorization: authToken(),
    },
  }, 2);
  return response.json();
}

export async function getLastLogin(userId: string) {
  const params = new URLSearchParams({ userId });
  const response = await fetchData(`/userLogin/last?${params.toString()}`, {
    method: "GET",
    headers: {
      Authorization: authToken(),
    },
  }, 2);
  return response.json();
}
export async function getExcelData() {
  const response = await fetchData(`/userLogin/excel`, {
    method: "GET",
    headers: {
      Authorization: authToken(),
    },
  }, 2);
  return response.json();
}

